import React from 'react';
import { Avatar, AvatarProps, styled, Typography } from '@mui/material';
import { color } from '../../themes/color';

interface UserInitialsAvatarProps extends AvatarProps {
  initials: string;
  hasGradientBackgroundColor: boolean;
  padding?: number;
}

const StyledAvatar = styled(Avatar, {
  // Avoid forwarding the `hasGradientBackgroundColor` and `padding` props to the DOM to prevent React warnings
  shouldForwardProp: (prop) => prop !== 'hasGradientBackgroundColor' && prop !== 'padding',
})<Omit<UserInitialsAvatarProps, 'initials'>>(({ theme, hasGradientBackgroundColor, padding }) => ({
  background: hasGradientBackgroundColor
    ? `linear-gradient(to right, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`
    : theme.palette.primary.main,
  color: theme.palette.common.white,
  padding,
  fontSize: '1rem',
  width: '32px',
  height: '32px',
}));

const UserInitialsAvatar = ({
  initials,
  hasGradientBackgroundColor,
  padding,
  ...restProps
}: UserInitialsAvatarProps) => (
  <StyledAvatar
    hasGradientBackgroundColor={hasGradientBackgroundColor}
    padding={padding}
    {...restProps}
  >
    {initials}
  </StyledAvatar>
);

export default UserInitialsAvatar;
